import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Extension } from '../models/extension';
import { ExtensionReview } from '../models/extension-review';
import { ExtensionOverviewRow } from '../models/extension-overview-row';

@Injectable({
  providedIn: 'root'
})
export class ExtensionApiService {

  private apiBaseUrl = `${environment.apiUrl}extension`;

  constructor(private httpClient: HttpClient) { }

  public getByContract(contractId: number): Observable<Extension[]> {
    return this.httpClient.get<Extension[]>(`${this.apiBaseUrl}/byContract/${contractId}`);
  }

  /** GET /api/extension/overview — all extensions with a missing-data breakdown (admin only). */
  public getOverview(): Observable<ExtensionOverviewRow[]> {
    return this.httpClient.get<ExtensionOverviewRow[]>(`${this.apiBaseUrl}/overview`);
  }

  public post(extension: Extension): Observable<Extension> {
    return this.httpClient.post<Extension>(this.apiBaseUrl, extension);
  }

  public put(extension: Extension): Observable<Extension> {
    return this.httpClient.put<Extension>(this.apiBaseUrl, extension);
  }

  public patchStatus(id: number, status: number): Observable<Extension> {
    return this.httpClient.patch<Extension>(`${this.apiBaseUrl}/${id}/status`, status);
  }

  public getReview(id: number): Observable<ExtensionReview> {
    return this.httpClient.get<ExtensionReview>(`${this.apiBaseUrl}/${id}/review`);
  }

  public delete(id: number): Observable<void> {
    return this.httpClient.delete<void>(`${this.apiBaseUrl}/${id}`);
  }
}
